var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DonutDisplay"},[_c('Card',{attrs:{"title":_vm.title}},[_c('pieChart',{attrs:{"width":468,"type":"pie","options":_vm.options,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }